import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '../../../atoms/Input/Checkbox';
import { CaretIcon } from '../../../atoms/Icon/Caret';
import Label from '../../../atoms/Label';
import { Item, ItemContainer, CheckboxContainer, LabelContainer, IconContainer } from '../style';

var DropdownItem = function DropdownItem(props) {
  var checked = props.checkboxState[props._id] ? props.checkboxState[props._id].show : true;
  return React.createElement(ItemContainer, {
    header: props.header
  }, React.createElement(Item, {
    left: props.left
  }, React.createElement(CheckboxContainer, {
    onClick: function onClick() {
      // eslint-disable-next-line no-console
      if (props.block) return console.log('Not resolution');
      return props.toggleCheckbox(props._id);
    }
  }, React.createElement(Checkbox, {
    checked: checked,
    color: props.color
  })), React.createElement(LabelContainer, {
    width: props.width
  }, React.createElement(Label, {
    tag: props.tag
  })), props.header ? React.createElement(IconContainer, {
    onClick: function onClick() {
      props.toggleShowList(props._id);
    }
  }, React.createElement(CaretIcon, {
    active: props.active
  })) : ''));
};

DropdownItem.propTypes = {
  _id: PropTypes.string,
  tag: PropTypes.string,
  left: PropTypes.string,
  width: PropTypes.string,
  header: PropTypes.bool,
  active: PropTypes.bool,
  checkboxState: PropTypes.object,
  color: PropTypes.string,
  toggleShowList: PropTypes.func,
  toggleCheckbox: PropTypes.func,
  toggleCheckboxList: PropTypes.func,
  block: PropTypes.bool
};
export default DropdownItem;